import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

// Page shell — the small stand-in for careers.co.jp's PageLayout (which we
// deliberately don't vendor: it carries the whole logged-in app chrome).
// Full-height themed background + a centered column.

export function Page({
  width = "narrow",
  children,
  className,
}: {
  /** narrow = candidate flow (matches the parent's questionnaire column), wide = admin. */
  width?: "narrow" | "wide";
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className="min-h-full bg-bg px-4 py-8 sm:py-10 text-text">
      <div className={cn("mx-auto", width === "narrow" ? "max-w-xl" : "max-w-5xl", className)}>
        {children}
      </div>
    </div>
  );
}
